export default {
  defaultSiteId: 'Member',
  newWorkflowAction: 'internal',
  overrideNewWorkFlowAction: false,
  endpoints: {
    newWorkflow: '/new',
    widget: '/explicit',
    escape: '/escape',
    submit: '/submit',
    autocomplete: '/autocomplete',
    login: '/login',
    logout: '/logout',
    interrupt: '/interrupt',
    table: {
      base: '/data/table',
      page: '/page',
      expander: '/expander',
      download: '/download',
      html: '/data/htmltable/page'
    },
    data: {
      pdf: '/data/workflow/pdf'
    },
    address: {
      base: '/data/address',
      search: '/search',
      lookup: '/lookup'
    }
  },
  http: {
    // root: 'http://ngo-forms.aptsolutions.net/comms',
    // root: 'http://ngo-public-test.aptsolutions.net/comms',
    // root: 'http://ngo-public-dev.aptsolutions.net/comms',
    // root: 'http://nteu-forms.aptsolutions.net/comms',
    // root: 'http://svh-forms.aptsolutions.net/comms',
    // root: 'http://svh-public-dev.aptsolutions.net/comms',
    // root: 'http://neu-forms.aptsolutions.net/comms',
    // root: 'http://neu-forms-test.aptsolutions.net/comms',
    // root: 'http://etu-forms.aptsolutions.net/comms',
    // root: 'http://etu-mypage-dev.aptsolutions.net/comms',
    // root: 'http://etu-mypage-test.aptsolutions.net/comms',
    // root: 'https://membership.neu.org.uk/comms',
    // root: 'https://webtest.sovereignhealthcare.co.uk/comms',
    // root: 'http://pre-live.sovereignhealthcare.co.uk/comms',
    // root: 'http://sas-demo-api.aptsolutions.net/comms',
    // root: 'http://rad-api.aptdev.net/comms',
    root: '/comms',
    timeout: 4000
  }
}
// https://dem-wrp-002.aptsolutions.net/demo-anniversary-wrap/



// WEBPACK FOOTER //
// ./src/config/api.js